// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"1abf81ca","227":"615d761a","329":"3b43fc51","423":"8b5f5c57","520":"9d352655","851":"d756c78b","897":"46e56e5a"}[chunkId] + ".css";
};